import { render, staticRenderFns } from "./SponsorStatistics.vue?vue&type=template&id=15d52160&scoped=true&"
import script from "./SponsorStatistics.vue?vue&type=script&lang=js&"
export * from "./SponsorStatistics.vue?vue&type=script&lang=js&"
import style0 from "./SponsorStatistics.vue?vue&type=style&index=0&id=15d52160&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d52160",
  null
  
)

export default component.exports